import api from './apiClient';
import {
  Suggestion,
  SuggestionCreate,
  SuggestionUpdate,
  SuggestionStatus,
  SuggestionListResponse,
} from '../types';

export const suggestionService = {
  createSuggestion: async (data: SuggestionCreate): Promise<Suggestion> => {
    const response = await api.post('/suggestions/', data);
    return response.data;
  },

  getMySuggestions: async (): Promise<Suggestion[]> => {
    const response = await api.get('/suggestions/my');
    return response.data;
  },

  getSuggestion: async (id: number): Promise<Suggestion> => {
    const response = await api.get(`/suggestions/${id}`);
    return response.data;
  },

  deleteSuggestion: async (id: number): Promise<void> => {
    await api.delete(`/suggestions/${id}`);
  },

  getAllSuggestions: async (params?: {
    status?: SuggestionStatus;
    skip?: number;
    limit?: number;
  }): Promise<SuggestionListResponse> => {
    const response = await api.get('/suggestions/admin/all', { params });
    return response.data;
  },

  respondToSuggestion: async (
    id: number,
    data: SuggestionUpdate
  ): Promise<Suggestion> => {
    const response = await api.patch(`/suggestions/admin/${id}/respond`, data);
    return response.data;
  },
};








